/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Classification_Classified_DateInputs */

const vi_product_classification_classified_date = /** @type {(inputs: Product_Classification_Classified_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày phân loại`)
};

/**

* @param {Product_Classification_Classified_DateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_classification_classified_date = /** @type {((inputs?: Product_Classification_Classified_DateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Classification_Classified_DateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_classification_classified_date(inputs)
});